var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 56,
    viewBox: "0 0 40 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.8136 16.6016C30.3767 20.1033 34.0746 26.2992 34.0746 33.3592C34.0746 44.289 25.2181 53.1466 14.2933 53.1466C12.6329 53.1466 11.0207 52.9409 9.4801 52.5555C12.528 54.4737 16.1344 55.5843 20.0012 55.5843C30.926 55.5843 39.7825 46.7259 39.7825 35.7969C39.7825 26.5298 33.4129 18.7521 24.8144 16.6016H24.8136Z",
    fill: "#825FD4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0736 33.3605C34.0736 26.3004 30.3756 20.1046 24.8125 16.6028C23.2719 16.2174 21.6598 16.0117 19.9993 16.0117C9.07371 16.0117 0.218018 24.8709 0.218018 35.7982C0.218018 42.8591 3.9151 49.055 9.47821 52.5567C11.0188 52.9422 12.631 53.1478 14.2914 53.1478C25.2162 53.1478 34.0727 44.2894 34.0727 33.3605H34.0736Z",
    fill: "#976CF3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2948 25.2128C25.6472 25.2128 29.9862 24.4532 29.9862 23.5161C29.9862 22.579 25.6472 21.8193 20.2948 21.8193C14.9425 21.8193 10.6035 22.579 10.6035 23.5161C10.6035 24.4532 14.9425 25.2128 20.2948 25.2128Z",
    fill: "#1A2037"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0598 0.665678L35.7677 8.37591L24.8285 10.7095L26.3242 0.0037729C26.9489 -0.0321772 27.5831 0.18881 28.0598 0.665678Z",
    fill: "#0783A0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.442 15.0986L18.6472 23.5184H15.586L10.4012 18.332C9.92453 17.8552 9.70466 17.2186 9.7406 16.5937L20.442 15.0986Z",
    fill: "#0783A0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7679 8.37695L36.3038 8.91303C37.1896 9.7991 37.1917 11.2371 36.3038 12.1242L24.9132 23.5183H18.6471L20.4419 15.0986L22.0973 14.867C23.4323 14.6799 24.4122 13.7007 24.5971 12.3664L24.8286 10.7105L35.7679 8.37695Z",
    fill: "#059ED3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3243 0.00488281L24.8286 10.7106L24.5971 12.3664C24.4121 13.7008 23.4322 14.6799 22.0972 14.8671L20.4419 15.0986L9.74048 16.5937C9.77008 16.0577 9.99205 15.53 10.4011 15.1198L24.8497 0.666788C25.2599 0.256533 25.7884 0.0344888 26.3243 0.00488281Z",
    fill: "#00BFFC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.494929107ac954822641f0e78cde2bf4.svg";
export { ForwardRef as ReactComponent };